module.exports = __webpack_public_path__ + "img/img17.d767bbd9.jpg";